// Duplica il bottone "Personalizza" e lo piazza sopra "Aggiungi al carrello"
// Luca Siviero

document.addEventListener("DOMContentLoaded", () => {
    const interval = setInterval(() => {
        const productSection = document.querySelector(".single-product-details.w-100");
        const originalBtn = document.querySelector("#customily-personalize-button");
        const addToCartWrapper = productSection?.querySelector(".add-to-cart__wrapper");

        // Aspetta che il bottone Customily sia inizializzato (non in running)
        if (
            productSection &&
            originalBtn &&
            addToCartWrapper &&
            !originalBtn.classList.contains("running")
        ) {
            clearInterval(interval);

            // Clona profondo
            const clone = originalBtn.cloneNode(true);

            // Rimuovi ID (evita conflitto DOM)
            clone.removeAttribute("id");
            clone.classList.remove("running");

            // Rendi full-width
            clone.style.display = "block";
            clone.style.width = "100%";
            clone.style.marginBottom = "10px";
            clone.style.height = "auto";
            clone.style.padding = "13px";

            // Associa il click al bottone originale
            clone.addEventListener("click", (e) => {
                e.preventDefault();
                e.stopPropagation();
                originalBtn.click();
            });

            // Inserisci PRIMA di add-to-cart
            addToCartWrapper.parentElement.insertBefore(clone, addToCartWrapper);
        }
    }, 300);
});
